export default "__VITE_ASSET__83b03a13__"